import styled from "styled-components"

import {Label} from "@irati/ui/src/Typography"

export default styled(Label)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  width: 37px;
  height: 37px;

  background: ${({theme}) => theme.colors.greys.white};
  border: 1px solid #979797;
  color: ${({theme}) => theme.colors.greys.black};
  border-radius: 50%;
`
